import { httpClient as http } from '@/utils/http'

// API基础路径
const API_BASE = '/mdm/transportTerms'

// 基础分页请求
export interface PageRequest {
  pageNum: number
  pageSize: number
}

// 分页结果
export interface PageResultVO<T> {
  records: T[]
  total: number
  pageNum: number
  pageSize: number
}

// 批量删除请求
export interface BatchDeleteRequest {
  ids: string[]
}

// 运输条款分页查询请求
export interface TransportTermsPageRequest extends PageRequest {
  tenantId?: string
  keyword?: string
  termsCode?: string
  termsName?: string
  enabled?: number
}

// 运输条款列表项视图对象
export interface TransportTermsListVO {
  id: string
  tenantId?: string
  termsCode: string
  termsName: string
  enabled: number
  isPlatformData?: boolean
}

// 运输条款详情视图对象
export interface TransportTermsVO {
  id: string
  tenantId?: string
  termsCode: string
  termsName: string
  enabled: number
  isPlatformData?: boolean
}

// 运输条款保存请求
export interface TransportTermsSaveRequest {
  id?: string
  tenantId?: string
  termsCode: string
  termsName: string
  enabled?: number
}

// 运输条款更新请求
export interface TransportTermsUpdateRequest extends TransportTermsSaveRequest {
  id: string
}

// 模糊搜索请求
export interface FuzzySearchRequest {
  keyword: string
  enabled?: number
}

// 查询平台数据请求
export interface QueryPlatformRequest {
  pageNum?: number
  pageSize?: number
  keyword?: string
  termsCode?: string
  termsName?: string
  tenantId?: string
}

// 运输条款API
export const transportTermsApi = {
  // 分页查询运输条款列表
  page: (params: TransportTermsPageRequest) => {
    return http.post<PageResultVO<TransportTermsListVO>>(`${API_BASE}/queryPage`, params)
  },

  // 查询运输条款列表
  list: (params: TransportTermsPageRequest) => {
    return http.post<TransportTermsListVO[]>(`${API_BASE}/queryList`, params)
  },

  // 模糊搜索运输条款
  search: (params: FuzzySearchRequest) => {
    return http.post<TransportTermsListVO[]>(`${API_BASE}/search`, params)
  },

  // 根据ID获取运输条款详情
  get: (id: string) => {
    return http.post<TransportTermsVO>(`${API_BASE}/getById`, { id })
  },

  // 保存运输条款（新增或更新）
  save: (params: TransportTermsSaveRequest) => {
    return http.post<boolean>(`${API_BASE}/save`, params)
  },

  // 更新运输条款
  update: (params: TransportTermsUpdateRequest) => {
    return http.post<boolean>(`${API_BASE}/save`, params)
  },

  // 删除运输条款
  delete: (ids: string[]) => {
    return http.post<boolean>(`${API_BASE}/delete`, {
      ids
    })
  },

  // 批量删除运输条款
  batchDelete: (params: BatchDeleteRequest) => {
    return http.post<boolean>(`${API_BASE}/delete`, {
      ids: params.ids
    })
  },

  // 更新状态
  updateStatus: (ids: string[], enabled: number) => {
    return http.post<boolean>(`${API_BASE}/updateStatus`, {
      ids,
      enabled
    })
  },

  // 批量更新状态
  batchUpdateStatus: (ids: string[], enabled: number) => {
    return http.post<boolean>(`${API_BASE}/batchUpdateStatus`, {
      ids,
      enabled
    })
  },

  // 根据运输条款代码查询
  getByCode: (code: string) => {
    return http.post<TransportTermsVO>(`${API_BASE}/getByCode`, { code })
  },

  // 查询启用状态的运输条款
  queryEnabled: (params: TransportTermsPageRequest) => {
    return http.post<TransportTermsListVO[]>(`${API_BASE}/queryEnabled`, params)
  },

  // 查询可关联的平台运输条款（分页）
  queryPlatformPage: (params: QueryPlatformRequest) => {
    return http.post<PageResultVO<TransportTermsListVO>>(`${API_BASE}/queryPlatformPage`, params)
  },

  // 批量关联平台运输条款
  batchAssociate: (platformIds: string[]) => {
    return http.post<boolean>(`${API_BASE}/batchAssociate`, {
      platformIds
    })
  },

  // 批量解除关联平台运输条款
  batchDisassociate: (platformIds: string[]) => {
    return http.post<boolean>(`${API_BASE}/batchDisassociate`, {
      platformIds
    })
  }
}
